module.exports = "<div ng-repeat=\"key in $ctrl.dataKeys\" ng-class=\"$ctrl.screenClass\" class=\"f-col span\"><div class=\"screen\"><div class=\"screen-head\"><b>{{$ctrl.getHead(key)}}</b> <i ng-click=\"$ctrl.removeScreen(key)\" class=\"icon-cancel\" title=\"{{:: 'Закрыть' | gettext }}\"></i></div><img ng-src=\"{{$ctrl.getUrl(key)}}\" alt=\"last screenshot\"><div class=\"time\">{{$ctrl.getTime(key)}}</div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/quad-last-screenshots/quad-last-screenshots.component.html
// module id = 988
// module chunks = 0